import type { RoadmapListResponsePagination } from './roadmapListResponsePagination';
import type { RoadmapListResponseRoadmapsItem } from './roadmapListResponseRoadmapsItem';

export interface RoadmapListResponse {
  /** 페이지네이션 정보 */
  pagination: RoadmapListResponsePagination;
  /** 조회된 로드맵 목록 */
  roadmaps: RoadmapListResponseRoadmapsItem[];
}
